import { ChartColors } from '.';

export const ReportDetails = {
  downloadFileName: 'Report_Details',
  groupOptions: [{ value: '-1', label: 'pe.allGroups' }],
  reportDownloadOptions: [
    // { value: 'PPT', label: 'Download PPT' },
    { value: 'XLS', label: 'Download Excel' },
    // { value: 'PDF', label: 'Download PDF' },
  ],
  compTypeOptionEmpty: { value: '', label: '' },
  compTypeVariablePayValue: 4,
  withVariablePay: 'w Variable Pay',
  withoutVariablePay: 'w/o Variable Pay',
  orgOverview: 'pe.orgOverview',
  allGaps: 'pe.allGaps',
  costPlanning: 'pe.costPlanning',
  allPayGaps: 'All Pay Gaps',
  department: 'Department',
  level: 'Level',
  quartile: 'Quartile',
  genderLabel: 'Gender',
  raceLabel: 'Race',
  genderAndRaceLabel: 'Gender and Race',
  demographicsBoth: 'Both',
  genderHeadcountID: 'gender_headcount',
  unAdjusted: 'unadjusted',
  adjusted: 'adjusted',
  gender: 'gender',
  average: 'Average',
  median: 'Median',
  annual: 'Annual',
  hourly: 'Hourly',
  quartileValueList: ['Q4', 'Q3', 'Q2', 'Q1'],
  quartileLabelList: [
    'pe.firstquartile',
    'pe.secondquartile',
    'pe.thirdquartile',
    'pe.fourthquartile',
  ],
  quartileList: [
    {
      value: 'Q1',
      label: 'pe.fourthquartile',
    },
    {
      value: 'Q2',
      label: 'pe.thirdquartile',
    },
    {
      value: 'Q3',
      label: 'pe.secondquartile',
    },
    {
      value: 'Q4',
      label: 'pe.firstquartile',
    },
  ],
  payGapAnalysis: {
    genderGroup: ['male', 'female', 'other'],
    gender: {
      male: {
        id: 'gender_pay_gap',
        title: 'pe.maleVsNonMale',
        colors: [ChartColors.GENDER_CHART.MALE, ChartColors.GENDER_CHART.MALE],
      },
      female: {
        id: 'female_pay_gap',
        title: 'pe.femaleVsNonFemale',
        colors: [ChartColors.GENDER_CHART.FEMALE, ChartColors.GENDER_CHART.FEMALE],
      },
      other: {
        id: 'other_pay_gap',
        title: 'pe.otherVsNonOther',
        colors: [ChartColors.GENDER_CHART.OHTER, ChartColors.GENDER_CHART.OHTER],
      },
    },
    raceGroup: ['white', 'black', 'hispanic', 'asian', 'other'],
    race: {
      white: {
        id: 'white_pay_gap',
        title: 'pe.whiteVsNonWhite',
        colors: [ChartColors.RACE_ETHNICITY_CHART.WHITE, ChartColors.RACE_ETHNICITY_CHART.WHITE],
      },
      black: {
        id: 'black_pay_gap',
        title: 'pe.blackVsNonBlack',
        colors: [ChartColors.RACE_ETHNICITY_CHART.BLACK, ChartColors.RACE_ETHNICITY_CHART.BLACK],
      },
      hispanic: {
        id: 'hispanic_pay_gap',
        title: 'pe.hispanicVsNonHispanic',
        colors: [
          ChartColors.RACE_ETHNICITY_CHART.HISPANIC,
          ChartColors.RACE_ETHNICITY_CHART.HISPANIC,
        ],
      },
      asian: {
        id: 'asian_pay_gap',
        title: 'pe.asianVsNonAsian',
        colors: [ChartColors.RACE_ETHNICITY_CHART.ASIAN, ChartColors.RACE_ETHNICITY_CHART.ASIAN],
      },
      other: {
        id: 'other_pay_gap',
        title: 'pe.otherVsNonOther',
        colors: [ChartColors.RACE_ETHNICITY_CHART.OTHER, ChartColors.RACE_ETHNICITY_CHART.OTHER],
      },
    },
  },
  payGapOptions: [
    { value: 'adjusted', label: 'pe.costPlanning.adjusted' },
    { value: 'unadjusted', label: 'pe.costPlanning.unadjusted' },
  ],
};
